import RequestManager from "src/requests/RequestManager";
import { TeamStatsByMatch } from "../interfaces";
import { isMockDataActive, matchStats } from "../mockData";
import { TeamStatsTask } from "../tasks";


// Se usa en VCardPartido/Resumen
export default async function getSummary(matchId: string): Promise<TeamStatsByMatch[]> {
    const task = new TeamStatsTask(matchId);
    let result;
    if(isMockDataActive) {
        result = matchStats;
    } else {
        result = await RequestManager.addRequest(task);
    }

    const parsedData = result.teams && result.teams.map((team: any):TeamStatsByMatch  => ({
        teamId: team.id || "",
        ballPossession: (team.stats && team.stats.ballPossession) || "0",
        cardsRed: (team.stats && team.stats.cardsRed) || "0",
        cardsYellow: (team.stats && team.stats.cardsYellow) || "0",
        offsides: (team.stats && team.stats.offsides) || "0",
        fouls: (team.stats && team.stats.fouls) || "0",
        shotsTotal: (team.stats && team.stats.shotsTotal) || "0",
        freeKicks: (team.stats && team.stats.freeKicks) || "0",
        penaltyKicks: (team.stats && team.stats.penaltyKicks) || "0",
        shotsBlocked: (team.stats && team.stats.shotsBlocked) || "0",
        corners: (team.stats && team.stats.corners) || "0",
        shotsOnGoal: (team.stats && team.stats.shotsOnGoal) || "0",
        scoringOpportunities: (team.stats && team.stats.scoringOpportunities) || "0",
        goals: (team.stats && team.stats.goals) || "0",
    }))

    return parsedData;
}


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getSummary.ts